module.exports = __webpack_public_path__ + "static/media/time-watch-svgrepo-com.acbc3835.svg";